import { StyleSheet } from 'react-native';

import { Theme } from '@constants';

import { isWebkit, isX1 } from '../../../helpers/Platform';

export const styles = StyleSheet.create({
  title: {
    marginLeft: Theme.px(90),
    marginTop: Theme.px(113),
    position: isX1 || isWebkit ? 'fixed' : 'absolute',
  },
});
